import React, { useMemo } from 'react';

import { Typography } from 'antd';

import CustomCopyToClipboard from 'components/CustomCopyToClipboard';
import { constants } from 'helpers/constants';
import type IProduct from 'interfaces/IProduct';

import NoticeProductPending from './NoticeProductPending';

interface IProps {
  currentProduct: IProduct;
  currentUserId: number;
  physicalProductPending: boolean;
}

export const SalePageLink = ({ currentProduct, currentUserId, physicalProductPending }: IProps) => {
  const clipBoardText = useMemo(() => {
    const { default_sales_page, producer_id, id } = currentProduct;
    const { SalesPage } = constants.links;
    const userIsOwerProduct = producer_id === currentUserId;

    const urlSalesPage = new URL(`${id}`, SalesPage);
    const urlSalesPageAffiliated = new URL(`${id}?a=${currentUserId}`, SalesPage);

    if (!default_sales_page && userIsOwerProduct) return urlSalesPage;

    return urlSalesPageAffiliated;
  }, [currentProduct, currentUserId]);

  return (
    <Typography.Text type='secondary' className='block'>
      {physicalProductPending ? (
        <NoticeProductPending />
      ) : (
        <CustomCopyToClipboard fullWidth disableUnderline text={clipBoardText.href} style={{ paddingTop: 1 }} />
      )}
    </Typography.Text>
  );
};
